export default __webpack_public_path__ + "static/media/medical_13.6c3da80a.jpg";